module.exports = __webpack_public_path__ + "assets/img/55c6-nz.svg";